<div class="overlay" *ngIf="isLoading | async">
    <mat-progress-spinner class="spinner" mode="indeterminate" strokeWidth="3" diameter="30">
    </mat-progress-spinner>
</div>